import React, { type ReactNode } from 'react'
import classNames from 'classnames'

interface Props {
  tag?: keyof JSX.IntrinsicElements
  children?: ReactNode
  className?: any
  size?: string
  style?: any
  shadow?: boolean
}

function Card(props: Props): JSX.Element {
  const Tag = props.tag ?? 'div'
  const _size = props.size ?? 'md'

  return (
    <Tag
      {...{ ...props, size: undefined, shadow: undefined }}
      className={classNames('card', `_${_size}`, props.className, {
        _shadow: props.shadow
      })}
      style={props.style}
    >
      {props.children}
    </Tag>
  )
}

export default Card
